import { mergeStyles } from '../../../../internal/utils/mergeStyles';
import * as mainStyles from './styles.module.css';
import * as groupStyles from './group.module.css';
export var getStyles = function getStyles(size) {
  return mergeStyles(mainStyles, groupStyles, require("./size/".concat(size, ".module.css")));
};